import {
    useEffect,
    useRef,
} from 'react'

interface UsePageTitleHookOptions {
    resetOnUnmount?: boolean
}

// Задать заголовок страницы (тэг <title>).
// Взято из Rooks/hooks/useDocumentTitle.ts
export function usePageTitle(
    title?: string | null,
    options?: UsePageTitleHookOptions
) {
    const {
        resetOnUnmount = false,
    } = options ?? {}

    const isBrowser = typeof window !== 'undefined'
    const prevTitleRef = useRef(isBrowser && title ? document.title : '')

    useEffect(() => {
        if (isBrowser && title) {
            document.title = title
            const lastTitle = prevTitleRef.current
            if (resetOnUnmount) {
                return () => {
                    document.title = lastTitle
                }
            }
        }
        return () => {
        }
    }, [title, isBrowser, resetOnUnmount])
}
